/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Sign_UpInputs */

const en_page_title_sign_up = /** @type {(inputs: Page_Title_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const nl_page_title_sign_up = /** @type {(inputs: Page_Title_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreren`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Page_Title_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_sign_up = /** @type {((inputs?: Page_Title_Sign_UpInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Sign_UpInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_sign_up(inputs)
	return en_page_title_sign_up(inputs)
});